import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X, ChevronDown, Globe } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const { language, setLanguage, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'de', label: 'DE' },
    { code: 'fr', label: 'FR' },
    { code: 'lv', label: 'LV' },
    { code: 'lt', label: 'LT' },
    { code: 'ee', label: 'EE' }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="text-2xl font-bold bg-gradient-to-r from-blue-900 to-teal-600 bg-clip-text text-transparent">
              0g Baltics
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('solutions')} className="text-gray-700 hover:text-blue-900 transition-colors font-medium">
              {t.nav.solutions}
            </button>
            <button onClick={() => scrollToSection('industries')} className="text-gray-700 hover:text-blue-900 transition-colors font-medium">
              {t.nav.industries}
            </button>
            <button onClick={() => scrollToSection('technologies')} className="text-gray-700 hover:text-blue-900 transition-colors font-medium">
              {t.nav.technologies}
            </button>
            <button onClick={() => scrollToSection('cases')} className="text-gray-700 hover:text-blue-900 transition-colors font-medium">
              {t.nav.references}
            </button>
            <button onClick={() => scrollToSection('blog')} className="text-gray-700 hover:text-blue-900 transition-colors font-medium">
              {t.nav.blog}
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-900 transition-colors font-medium">
              {t.nav.contact}
            </button>
          </nav>

          {/* Language Switcher & Mobile Menu */}
          <div className="flex items-center space-x-4">
            {/* Language Dropdown */}
            <div className="relative">
              <button
                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
                className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <Globe className="w-4 h-4" />
                <span className="font-medium">{language.toUpperCase()}</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              
              {langDropdownOpen && (
                <div className="absolute right-0 mt-2 w-32 bg-white rounded-lg shadow-lg border border-gray-200 py-2">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      onClick={() => {
                        setLanguage(lang.code);
                        setLangDropdownOpen(false);
                      }}
                      className={`w-full text-left px-4 py-2 hover:bg-gray-100 transition-colors ${
                        language === lang.code ? 'bg-blue-50 text-blue-900 font-medium' : 'text-gray-700'
                      }`}
                    >
                      {lang.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('solutions')} className="text-left text-gray-700 hover:text-blue-900 transition-colors font-medium py-2">
                {t.nav.solutions}
              </button>
              <button onClick={() => scrollToSection('industries')} className="text-left text-gray-700 hover:text-blue-900 transition-colors font-medium py-2">
                {t.nav.industries}
              </button>
              <button onClick={() => scrollToSection('technologies')} className="text-left text-gray-700 hover:text-blue-900 transition-colors font-medium py-2">
                {t.nav.technologies}
              </button>
              <button onClick={() => scrollToSection('cases')} className="text-left text-gray-700 hover:text-blue-900 transition-colors font-medium py-2">
                {t.nav.references}
              </button>
              <button onClick={() => scrollToSection('blog')} className="text-left text-gray-700 hover:text-blue-900 transition-colors font-medium py-2">
                {t.nav.blog}
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-blue-900 transition-colors font-medium py-2">
                {t.nav.contact}
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;